import { render } from "./addeditassetcategoryattribute.vue?vue&type=template&id=48c64691"
import script from "./addeditassetcategoryattribute.vue?vue&type=script&lang=js"
export * from "./addeditassetcategoryattribute.vue?vue&type=script&lang=js"

import "./addeditassetcategoryattribute.vue?vue&type=style&index=0&id=48c64691&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\EngeeGit\\EngeeAPI\\AdminPanel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__